import React from "react";
import { TOTAL_COUNTRIES, TOTAL_DESTINATIONS } from "@/data/destinations";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="bg-aio-ink text-aio-bg py-16"
  >
    <div className="max-w-[1440px] mx-auto px-6 sm:px-12 lg:px-20 grid grid-cols-1 md:grid-cols-12 gap-10">
      <div className="md:col-span-6">
        <p className="font-display text-4xl sm:text-5xl leading-tight">A.I.O</p>
        <p className="text-[10px] uppercase tracking-[0.32em] text-aio-bg/60 mt-2 mb-6">
          All In One Sourcing Specialists
        </p>
        <p className="max-w-md text-aio-bg/70 text-sm leading-relaxed">
          Private sourcing for luxury travel. {TOTAL_DESTINATIONS}+ curated
          stays across {TOTAL_COUNTRIES} countries, delivered by a single
          specialist assigned to you.
        </p>
      </div>
      <div className="md:col-span-3">
        <p className="text-[10px] uppercase tracking-[0.32em] text-aio-bg/60 mb-4">
          The Catalog
        </p>
        <ul className="space-y-2 text-sm text-aio-bg/80">
          <li>130+ Destinations</li>
          <li>40+ Countries</li>
          <li>Curated by hand</li>
          <li>Confirmation in 24h</li>
        </ul>
      </div>
      <div className="md:col-span-3">
        <p className="text-[10px] uppercase tracking-[0.32em] text-aio-bg/60 mb-4">
          Access
        </p>
        <ul className="space-y-2 text-sm text-aio-bg/80">
          <li><a href="#reserve" className="hover:text-aio-bg">Request Brochure</a></li>
          <li><a href="#catalog" className="hover:text-aio-bg">Browse Catalog</a></li>
        </ul>
      </div>
    </div>
    <div className="max-w-[1440px] mx-auto px-6 sm:px-12 lg:px-20 mt-14 pt-8 border-t border-aio-bg/15 text-[11px] uppercase tracking-[0.28em] text-aio-bg/60 flex flex-col sm:flex-row justify-between gap-4">
      <span>&copy; {new Date().getFullYear()} A.I.O — All In One Sourcing Specialists.</span>
      <span>Vol. I &mdash; The 2026 Catalog</span>
    </div>
  </footer>
);
